export const STORAGE_PATH = "https://storage.googleapis.com/we-tickets-25-v2";
export const RECAPTCHA_SITE_KEY = "6LdTUNwrAAAAAP1QGQZF0nRvXHv1uHi6gA9mPQoJ";
// export const LOCALHOST_RECAPTCHA_SITE_KEY = "6LfUYdwrAAAAAJ-aS3m4vNFqN2PXHOixN1pk6niU";
export const paymentMethod = {
  CASH_ON_DELIVERY: {
    label: "Cash on Delivery",
    value: "CASH_ON_DELIVERY",
  },
  CARD: {
    label: "Credit Card",
    value: "CARD",
  },
};
